/* eslint-disable @typescript-eslint/no-extra-semi */
import { useState, useEffect } from 'react'

// for dynamically importing all flags
export async function createFlagStore(ary) {
  const promises = ary.map(({ node: { iso_country_code } }) =>
    import(`../static/images/flags/${iso_country_code.toLowerCase()}.png`).then(
      (item) => ({
        iso_country_code,
        flag: item.default,
      })
    )
  )
  const flagArray = await Promise.all(promises)
  const flagStore = new Map()
  flagArray.forEach(({ flag, iso_country_code }) => {
    flagStore.set(iso_country_code, flag)
  })
  return flagStore
}

// hook to use
// usage:
// const flagStore = useFlagStore(data)
export default function useFlagStore(data) {
  const [flags, setFlags] = useState(null)
  useEffect(() => {
    ;(async () => {
      const store = await createFlagStore(data.allRoamingPrice.edges)
      setFlags(store)
    })()
  }, [])
  return flags
}

// hook to get individual flags
export function useFlag(iso_country_code) {
  const [flag, setFlag] = useState('')
  useEffect(() => {
    ;(async () => {
      const flagModule = await import(
        `../static/images/flags/${iso_country_code.toLowerCase()}.png`
      )
      setFlag(flagModule.default)
    })()
  }, [])
  return flag
}
